export const getAssetUrl = (assetName) => process.env.STORAGE_LINK + '/' + assetName;
//# sourceMappingURL=getAssetUrl.js.map